import React from 'react';
import { Route } from 'react-router-dom';
import ScormFile from '../views/ScormFile';

export default [
  <Route key="01" exact path="/scormFile/:id" component={ScormFile} />
];